export default () => ({
  name: "",
  fanpageId: null,
  description: "",
  status: "",
  template: "",
  phone: "",
  botId: null,
});

